export default Object.freeze({
  PICTURES: 'PICTURES',
  MATERIAL: 'MATERIAL',
  INTERNAL_SCAN: 'INTERNAL_SCAN',
  EXTERNAL_SCAN: 'EXTERNAL_SCAN',
  OLD_TREATMENT: 'OLD_TREATMENT',
});
